import { Typography } from "@mui/material";
import { AvatarWithSideContent } from "components/layout/avatar/AvatarWithSideContent";
import { T } from "components/util/t";
import { useDialogState } from "hooks/useDialogState";
import { RankingsDialog } from "./RankingsDialog";

export const NewRankingsTableRow = ({ ranking, selectedSeries, selectedDivision, filter }) => {
    const [dialogOpen, openDialog, closeDialog] = useDialogState();

    return (
        <>
            <tr onClick={openDialog}>
                <td><Typography variant="h7">{ranking.place}</Typography></td>
                <td>
                    <AvatarWithSideContent
                        athlete={ranking.athlete}
                        title={<Typography variant="subtitle3">{ranking.place === 1 ? `${ranking.athlete.name} 🏆` : ranking.athlete.name}</Typography>}
                        subtitle={ranking.displayProperty && <Typography variant="body2" color="textSecondary">{ranking.displayProperty}</Typography>}
                    />
                    <RankingsDialog
                        dialogOpen={dialogOpen}
                        closeDialog={closeDialog}
                        ranking={ranking}
                        selectedSeries={selectedSeries}
                        selectedDivision={selectedDivision}
                        filter={filter}
                    />
                </td>
                <td>
                    <Typography variant="subtitle2" display="inline">{ranking.points.toLocaleString()}</Typography>
                    <Typography color="text.lighter" display="inline">{" "}<T>pts</T></Typography>
                </td>
            </tr>
        </>
    );
};
